import {
  AlertScopeType,
  DisconnectionAlertSettingResponse,
} from '@magnetar/admin-api-interfaces'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'

interface UseDisconnectionAlertSettingParams {
  scopeType: AlertScopeType
  scopeId?: number
  enabled?: boolean
}

/**
 * 取得斷線警示設定
 */
export function useDisconnectionAlertSetting({
  scopeType,
  scopeId,
  enabled = true,
}: UseDisconnectionAlertSettingParams) {
  const { token } = useAuth()

  const queryParams = new URLSearchParams()
  queryParams.append('scope_type', scopeType)
  if (scopeId !== undefined) queryParams.append('scope_id', String(scopeId))

  const shouldFetch = enabled && token

  const { data, error, mutate } = useGet<DisconnectionAlertSettingResponse>(
    shouldFetch ? `/api/disconnection-alert/settings?${queryParams.toString()}` : null,
    undefined,
    token ?? '',
  )

  return {
    setting: data?.data ?? null,
    isLoading: shouldFetch && !error && !data,
    isError: error,
    mutate,
  }
}
